import ReactDOM from 'react-dom/client';
import App from './app';
import {channelConfig} from "../../shared";

const root = ReactDOM.createRoot(document.getElementById('takeover-root'));

export default function InitializeTakeover(data, channel) {
    root.render(<App config={channelConfig({forceAssetHeight: true}, channel)} data={data}/>);
}